import {
  Stack,
  Typography,
  Paper,
} from '@mui/material'

const NotesTab = ({ entry }) => {
  return (
    <Stack spacing={3}>
      <Typography variant="h6" gutterBottom>
        Notes & Observations
      </Typography>
      
      {entry?.notes?.active ? (
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="body1">
            {entry.notes.active}
          </Typography>
        </Paper>
      ) : (
        <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No Active Notes
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Edit this entry to add notes and observations.
          </Typography>
        </Paper>
      )}

      {entry?.notes?.archived && entry.notes.archived.length > 0 && (
        <>
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            Archived Notes
          </Typography>
          <Stack spacing={1}>
            {entry.notes.archived.map((note, index) => (
              <Paper key={index} sx={{ p: 2 }} variant="outlined">
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  {note.user} - {new Date(note.timestamp?.toDate?.() || note.timestamp).toLocaleDateString()}
                </Typography>
                <Typography>
                  {note.content}
                </Typography>
              </Paper>
            ))}
          </Stack>
        </>
      )}
    </Stack>
  )
}

export default NotesTab